
import { memo } from "react";
import TaskCard from "../TaskCard";

interface Task {
  id: string;
  title: string;
  status: string;
  assignedTo: string;
  date: string;
  location: string;
  priority: string;
  estimatedHours: number;
  taskType: string;
  createdByType: string;
  deleted_at?: string;
  deleted_by?: string;
  deleted_by_name?: string;
}

interface TaskGridProps {
  tasks: Task[];
  onEdit: (taskId: string) => void;
  onDelete: (taskId: string) => void;
}

// Memoize individual TaskCard to prevent unnecessary re-renders
const MemoizedTaskCard = memo(TaskCard);

const TaskGrid = ({ tasks, onEdit, onDelete }: TaskGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {tasks.map((task) => (
        <MemoizedTaskCard 
          key={task.id} 
          task={{
            ...task,
            status: task.status as "pending" | "in-progress" | "completed" | "deleted",
            priority: task.priority as "low" | "medium" | "high",
            taskType: task.taskType as "installation" | "repair" | "inspection" | "maintenance",
            createdByType: task.createdByType as "admin" | "employee"
          }}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

// Memoize the entire TaskGrid component
export default memo(TaskGrid);
